module.exports = __webpack_public_path__ + "img/Hand_31_05_07.efb12c0b.png";